import { useState } from "react";
import classNames from "classnames";
import styles from "./Login.module.scss";
import defaultPage from "../Page.module.scss";
import { getData } from "../../utils/data";
import { EData } from "../../interfaces/enum";
import { LoginData } from "../../interfaces/interfaces";
import { getLogo } from "../../utils/assets";
import Form from "../../components/Form/Form";
import { ERoute } from "../../routes/routes";
import { useLocation } from "react-router-dom";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const data: LoginData = getData(EData.LOGIN) as LoginData;
  const logo: string = getLogo();
  const currentPos: ERoute = useLocation().pathname as ERoute;

  return (
    <div className={classNames(defaultPage.page, "flex-column")}>
      {isLoading && (
        <div className={classNames(styles.loaderContainer)}>
          <div className={classNames(styles.loader)} />
        </div>
      )}
      <div className={classNames(styles.logo)}>
        <img src={logo} alt={logo} />
      </div>
      <div className="container d-flex justify-content-center">
        <Form
          data={data}
          isSignup={currentPos === ERoute.SIGNUP}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </div>
    </div>
  );
};

export default Login;
